import { BookText, Boxes, GitFork, Network, ScrollText, Search, Wand2 } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { cn } from '../../lib/cn.js';

interface ShellNavProps {
  readonly repo: string | null;
}

const baseLinks = [
  { to: '/repos', label: 'Repos', icon: Boxes, end: true },
  { to: '/groups', label: 'Groups', icon: GitFork, end: true },
];

export function ShellNav({ repo }: ShellNavProps): JSX.Element {
  return (
    <nav className="flex items-center gap-0.5 rounded-xl border border-border-subtle bg-deep/60 p-0.5">
      {baseLinks.map(({ to, label, icon: Icon, end }) => (
        <NavItem key={to} to={to} label={label} icon={<Icon className="h-3.5 w-3.5" />} end={end} />
      ))}
      {repo && (
        <>
          <span className="mx-0.5 h-4 w-px bg-border-subtle" aria-hidden />
          <NavItem
            to={`/repos/${repo}`}
            label="Graph"
            icon={<Network className="h-3.5 w-3.5" />}
            end
          />
          <NavItem
            to={`/repos/${repo}/explore`}
            label="Explore"
            icon={<Search className="h-3.5 w-3.5" />}
          />
          <NavItem
            to={`/repos/${repo}/impact`}
            label="Impact"
            icon={<Wand2 className="h-3.5 w-3.5" />}
          />
          <NavItem
            to={`/repos/${repo}/cypher`}
            label="Cypher"
            icon={<ScrollText className="h-3.5 w-3.5" />}
          />
          <NavItem
            to={`/repos/${repo}/wiki`}
            label="Wiki"
            icon={<BookText className="h-3.5 w-3.5" />}
          />
        </>
      )}
    </nav>
  );
}

interface NavItemProps {
  readonly to: string;
  readonly label: string;
  readonly icon: React.ReactNode;
  readonly end?: boolean;
}

function NavItem({ to, label, icon, end }: NavItemProps): JSX.Element {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition-all',
          isActive
            ? 'bg-accent/15 text-accent shadow-[inset_0_0_0_1px_rgba(124,58,237,0.35)]'
            : 'text-text-secondary hover:bg-hover hover:text-text-primary',
        )
      }
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}
